// jwt.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '../service/common/common.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private commonService: CommonService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!request.url.includes('assets')) {
      const apiHost = this.commonService.configJson.LoopBackApi;
      if (request.url.startsWith(apiHost)) {
        const userKey = `oidc.user:${this.commonService.configJson.IDMAuthorityUrl}/auth:${this.commonService.configJson.IDMClientId}`;
        const userInStorage = localStorage.getItem(userKey);

        if (userInStorage) {
          const user = JSON.parse(userInStorage);
          const accessToken = user.access_token;

          // 克隆请求并添加访问令牌到请求头
          const authRequest = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${accessToken}`)
          });

          // 继续处理请求
          return next.handle(authRequest);
        }
      }
    }

    return next.handle(request);
  }
}